export default {
    config: {
        shareUrl: {
            default: {
                baseUrl: 'https://connect.ok.ru/offer',
                params: {
                    url: 'url',
                    title: 'title',
                    description: 'description',
                    imageUrl: 'image'
                }
            }
        }
    },

    popupDimensions: [800, 520],

    i18n: {
        az: 'Odnoklassniki',
        be: 'ÐžÐ´Ð½Ð¾ÐºÐ»Ð°ÑÑÐ½Ð¸ÐºÐ¸',
        en: 'Odnoklassniki',
        hy: 'Odnoklassniki',
        ka: 'Odnoklasniki',
        kk: 'ÐžÐ´Ð½Ð¾ÐºÐ»Ð°ÑÑÐ½Ð¸ÐºÐ¸',
        ro: 'Odnoklassniki',
        ru: 'ÐžÐ´Ð½Ð¾ÐºÐ»Ð°ÑÑÐ½Ð¸ÐºÐ¸',
        tr: 'Odnoklasniki',
        tt: 'ÐžÐ´Ð½Ð¾ÐºÐ»Ð°ÑÑÐ½Ð¸ÐºÐ¸',
        uk: 'ÐžÐ´Ð½Ð¾ÐºÐ»Ð°ÑÐ½Ð¸ÐºÐ¸',
        uz: 'Odnoklassniki'
    },

    color: '#f70'
};
